import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import {
  formatDataHoraBR,
  type ExecucaoIntegracao,
} from "@/api/escala.service";
import { detalheContadores } from "@/utils/escalaIntegracao";

export type DetalheExecucao = {
  execucao: ExecucaoIntegracao;
  tipo: "inseridos" | "atualizados" | "erros";
};

const TITULO = {
  inseridos: "Inseridos",
  atualizados: "Atualizados",
  erros: "Erros",
} as const;

// O que uma execução da sincronização criou, alterou ou recusou. Quantidades vêm dos
// contadores; os erros são as primeiras ocorrências que o servidor devolve.
export function EscalaIntegracaoDetalheModal({
  detalhe,
  onClose,
}: {
  detalhe: DetalheExecucao | null;
  onClose: () => void;
}) {
  const { execucao, tipo } = detalhe ?? {};
  const linhas =
    execucao && tipo && tipo !== "erros"
      ? detalheContadores(execucao.contadores, tipo)
      : [];

  return (
    <Dialog
      open={!!detalhe}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      scroll="paper"
    >
      <DialogTitle>
        {tipo
          ? `${TITULO[tipo]} — ${formatDataHoraBR(execucao?.iniciada_em)}`
          : ""}
      </DialogTitle>

      <DialogContent dividers>
        {execucao && tipo === "erros" && (
          <Stack spacing={1.5}>
            <Stack component="ul" spacing={0.75} sx={{ pl: 2.5, m: 0 }}>
              {execucao.erros.map((e, i) => (
                <Typography component="li" variant="body2" key={i}>
                  {e.empresa || e.chave ? (
                    <strong>
                      {[e.empresa, e.chave].filter(Boolean).join(" / ")}:{" "}
                    </strong>
                  ) : null}
                  {e.mensagem}
                </Typography>
              ))}
            </Stack>
            {execucao.erros_total > execucao.erros.length && (
              <Alert severity="info">
                {`Mostrando as primeiras ${execucao.erros.length} de ${execucao.erros_total} ocorrências.`}
              </Alert>
            )}
          </Stack>
        )}

        {execucao && tipo && tipo !== "erros" && (
          <Stack spacing={1}>
            {linhas.map(([rotulo, n]) => (
              <Stack
                key={rotulo}
                direction="row"
                justifyContent="space-between"
              >
                <Typography variant="body2">{rotulo}</Typography>
                <Typography variant="body2" fontWeight={700}>
                  {n}
                </Typography>
              </Stack>
            ))}
            <Typography variant="caption" color="text.secondary" sx={{ pt: 1 }}>
              A sincronização guarda as quantidades de cada execução, não a
              lista dos registros.
            </Typography>
          </Stack>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
